import { supabase } from '../supabase';

// A client's consent to share health information with their coach (migration 083; owner, 18 October
// 2026). Asked at sign-up (a separate tick, beside the terms), once for clients who joined before, and
// changeable any time in Settings. Each answer is a new row; the latest counts. Staff see a client's
// health conditions, GLP-1 details and body scans only while the latest answer is yes to this wording.
// Change the wording only with a new version: an answer to an older wording no longer counts.
export const HEALTH_SHARING_VERSION = 1;
// Word for word as migration 083 stores version 1 (health_sharing_notices); a test compares the two.
export const HEALTH_SHARING_TEXT =
  "Share my health information with my Cipher coach and Cipher's lead coach, so they can adapt my coaching: "
  + 'health conditions, GLP-1 medication details and body scans (weight, body fat and muscle). Eating-disorder '
  + 'history is never shared. My training and weight stay visible to my coach either way. I can change this at '
  + 'any time in Settings.';

/** My latest answer: { answered: false } or { answered: true, shares, current } (current: to this wording). */
export async function getMyHealthSharing(userId) {
  const { data, error } = await supabase
    .from('health_sharing_consents')
    .select('shares, notice_version, created_at')
    .eq('user_id', userId)
    .order('id', { ascending: false }) // the database numbers answers in the order they are stored
    .limit(1);
  if (error) throw error;
  const latest = data?.[0];
  if (!latest) return { answered: false, shares: false, current: false };
  return { answered: true, shares: latest.shares === true, current: latest.notice_version === HEALTH_SHARING_VERSION };
}

/** Records an answer (method: 'signup' | 'prompt' | 'settings'); throws if it was not stored. */
export async function recordHealthSharing(userId, shares, method) {
  const { data, error } = await supabase
    .from('health_sharing_consents')
    .insert({ user_id: userId, shares: !!shares, notice_version: HEALTH_SHARING_VERSION, method })
    .select('id')
    .single();
  if (error) throw error;
  if (!data?.id) throw new Error('Your answer was not saved. Please try again.');
  return data;
}

/** For a coach's screen: has this client of theirs agreed? true, false, or null (not theirs to know). */
export async function clientSharesHealth(clientId) {
  const { data, error } = await supabase.rpc('my_client_shares_health', { p_client: clientId });
  if (error) throw error;
  return data ?? null;
}
